import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import {Modal, Button, FormGroup, ControlLabel, FormControl, Radio} from 'react-bootstrap';
import axios from 'axios';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import ErrorMessageContainer from "./ErrorMessageContainer";

require('moment/locale/el');

export default class AddDeliverableModal extends Component {
    constructor() {
        super();

        this.state = {
            title: "",
            deadline: moment(),
            loading: false,
            errors: [],
            show_modal: false,
        };

        this.attachmentInputRef = React.createRef();

        this.handleValueChange = this.handleValueChange.bind(this);
        this.open = this.open.bind(this);
        this.close = this.close.bind(this);
        this.submit = this.submit.bind(this);
    }

    handleValueChange(key, value) {
        this.setState({[key]: value});
    }

    open() {
        this.setState({
            title: "",
            deadline: moment(),
            loading: false,
            errors: [],
            show_modal: true,
        });
    }

    close() {
        this.setState({show_modal: false});
    }

    submit() {
        if (!this.state.loading) {
            this.setState({
                errors: [],
                loading: true
            }, () => {
                const url = this.props.post_url;
                const file = this.attachmentInputRef.current.files[0];
                const deadline = (this.state.deadline !== null ? this.state.deadline.format("DD/MM/YYYY") : "");
                const formData = new FormData();

                formData.append('title', this.state.title);
                formData.append('deadline', deadline);

                if (file) {
                    formData.append('attachment', file);
                }

                axios
                    .post(url, formData, {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    })
                    .then((response) => {
                        this.setState({loading: false}, () => {
                            window.location = this.props.redirect_url;
                        });
                    })
                    .catch((failure) => {
                        this.setState({
                            errors: failure.response.data,
                            loading: false
                        });
                    });
            });
        }
    }

    render() {
        return (
            <div className="row">
                <div className="col-md-12">
                    <Button bsStyle="primary" onClick={this.open}>
                        <i className="fa fa-plus"></i> {window.__js_contracts.add_deliverable}
                    </Button>

                    <Modal show={this.state.show_modal} onHide={this.close}>
                        <Modal.Header closeButton>
                            <Modal.Title>{window.__js_contracts.add_deliverable}</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <ErrorMessageContainer errors={this.state.errors}/>

                            <FormGroup controlId="title">
                                <ControlLabel>{window.__js_contracts.title}*</ControlLabel>
                                <FormControl
                                    type="text"
                                    value={this.state.title}
                                    onChange={(e) => this.handleValueChange("title", e.target.value)}
                                />
                            </FormGroup>

                            <FormGroup controlId="deadline">
                                <ControlLabel>{window.__js_contracts.deliverable_date}*</ControlLabel>
                                <DatePicker
                                    className="form-control"
                                    id="deadline"
                                    selected={this.state.deadline}
                                    onChange={(selected_date) => this.handleValueChange("deadline", selected_date)}
                                    dateFormat="DD/MM/YYYY"
                                    locale="el"
                                />
                            </FormGroup>

                            <FormGroup controlId="attachment">
                                <ControlLabel>{window.__js_contracts.attached_file}</ControlLabel>
                                <input
                                    type="file"
                                    className="form-control"
                                    name="attachment"
                                    id="attachment"
                                    ref={this.attachmentInputRef}
                                />
                            </FormGroup>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button onClick={this.close}>{window.__js_general.close}</Button>
                            <Button onClick={this.submit}
                                    bsStyle="primary"
                                    disabled={this.state.loading}>
                                {window.__js_general.save}
                            </Button>
                        </Modal.Footer>
                    </Modal>
                </div>
            </div>
        );
    }
}

if (document.getElementById("add-deliverable-modal")) {
    let element = document.getElementById("add-deliverable-modal");
    let post_url = element.getAttribute("data-post-url");
    let redirect_url = element.getAttribute("data-redirect-url");
    ReactDOM.render(
        <AddDeliverableModal
            post_url={post_url}
            redirect_url={redirect_url}
        />,
        element
    );
}